import 'babel-polyfill'
import 'classlist-polyfill'
import 'element-closest'
import 'webcrypto-shim'
import 'blueimp-canvas-to-blob'
import { polyfill as smoothscrollPolyfill } from 'smoothscroll-polyfill'

import { TextDecoder, TextEncoder } from 'text-encoding'

smoothscrollPolyfill()

if (!Node.prototype.contains) {
  // from here: https://github.com/webmodules/node-contains/blob/b7335eb2e36e6d01b0759d702188a717c95ee110/index.js
  Node.prototype.contains = function contains (child: Node) {
    // tslint:disable-next-line:no-bitwise
    return this === child || !!(this.compareDocumentPosition(child) & 16)
  }
}

window.TextEncoder = window.TextEncoder || TextEncoder
window.TextDecoder = window.TextDecoder || TextDecoder
declare global {
  interface Window {
    d3: any
  }
}

// The line below should fix DataCloneError from Sentry (see https://tangle.atlassian.net/browse/FRO-1707)
delete window.d3
